export default {
  mounted(el, binding) {
    if (binding.value || binding.value === undefined) {
      const child = document.createElement('span')
      child.classList.add('wordCountBox')
      el.classList.add('wordCountTarget')
      const scrollBox = document.querySelector(
        '.powerEdit__right-panel'
      ) as Element

      const setPosition = () => {
        window.requestAnimationFrame(() => {
          const boundingBox = el.getBoundingClientRect()
          const style = styleFromRect(boundingBox, child.offsetWidth)
          Object.assign(child.style, style)
        })
      }

      const generateText = () => {
        checkLength()
        const length = el.innerText.split(' ').length
        const target = 40
        const text = `${length} / ${target} word max`
        child.innerText = text
        if (length > target) {
          child.classList.add('error')
        } else {
          child.classList.remove('error')
        }
      }

      const checkLength = () => {
        const length = el.innerText.trim().split(' ').length
        const target = 40
        const isLengthOk = length <= target
        if (!isLengthOk) {
          el.classList.add('overLength')
        } else {
          el.classList.remove('overLength')
        }
      }

      const blurListener = el.addEventListener('blur', () => {
        document.body.removeChild(child)
        document.removeEventListener('scroll', setPosition)
        scrollBox?.removeEventListener('blur', blurListener)
      })

      const setup = () => {
        scrollBox?.addEventListener('scroll', setPosition)
        el.onfocus = e => {
          document.body.appendChild(child)
          generateText()
          setPosition()
          document.addEventListener('scroll', setPosition)
        }
        el.onkeyup = e => {
          generateText()
          setPosition()
        }
        checkLength()
      }

      setup()
    }
  },
}

const styleFromRect = (rect: DOMRect, width: number) => {
  return {
    position: 'absolute',
    top: `${rect.bottom + window.scrollY + 9}px`,
    left: `${rect.right - width + window.scrollX}px`,
  }
}
